module.exports = __webpack_public_path__ + "static/media/sneak_peek_onboarding@3x.7811a043.png";